export default __webpack_public_path__ + "static/media/h&m.b04a23d6.png";